export default __webpack_public_path__ + "static/media/1191.75549172.png";